import React from 'react';
import ReactDOM from 'react-dom';
import './i18n/i18n';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import './appInsights';

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById('root')
);
